import { METRICS_INFO, JANK_METRICS_INFO } from './constants';

export const parseMetricsValue = (value, name) => {
  if (typeof value === 'undefined' || value === null) {
    return '-  -';
  }
  const parsedValue = parseInt(value, 10);

  if (name === METRICS_INFO.get('speedIndex') || name === 'speedIndex') {
    return parsedValue.toFixed(0);
  }
  if ([METRICS_INFO.get('score'), JANK_METRICS_INFO.get('score'), 'score'].includes(name)) {
    return (value * 100).toFixed(0);
  }
  return `${parsedValue} ms`;
};

export const isRegressionDetectedMetrics = (regressionData, metric) => {
  if (!regressionData || !regressionData.metrics) {
    return false;
  }

  const metricData = regressionData.metrics[metric];

  // Performance V2
  if (typeof metricData === 'object') {
    return metricData.outlier.status;
  }
  // Performance V1
  return !!metricData;
};
